import { dateFormater } from "../helpers";
import getTomorrowDate from "./getTomorrowDate";

const disablePrevDateByHour = (hour: number) => {
    const today = new Date();
    if (today.getHours() >= hour) {
      return getTomorrowDate();
    } else {
      return dateFormater(today);
    }
};

export default disablePrevDateByHour;